export default __webpack_public_path__ + "static/start_1-dccf079052dcde196695512c43bac994.png";